import React from 'react';
import I18n from 'app/i18n';
import wheelUrl from 'images/landing-affiliates/wheel.svg';
import {ArrowIcon} from './AffiliatesIcons';
import {PARTNER_REGISTER_URL} from './affiliatesLinks';

const EMBER_KEYS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l'
];

const TICKER_KEYS = [
    't1',
    't2',
    't3',
    't4',
    'eyebrow',
    't5'
];

const tickerItems = (copy: string): React.ReactElement[] => TICKER_KEYS.map(key => <span key={`${copy}-${key}`}>
    {I18n.t(`affiliate.${key}`)}
</span>);

const AffiliatesHero = (): React.ReactElement => <>
    <section className="hero">
        <div className="wheel" aria-hidden="true">
            <img className="spin" src={wheelUrl} alt=""/>
            <div className="orbit"><span className="ball"/></div>
        </div>
        <div className="embers" aria-hidden="true">
            {EMBER_KEYS.map(key => <i key={key}/>)}
        </div>
        <div className="wrap">
            <div className="hero-in">
                <div className="eyebrow rv">{I18n.t('affiliate.eyebrow')}</div>
                <h1 className="rv" dangerouslySetInnerHTML={{__html: I18n.t('affiliate.h1')}}/>
                <p className="lead rv">{I18n.t('affiliate.lead')}</p>
                <div className="instant rv">
                    <span className="instant-tag">
                        <span className="pulse"/>
                        <span>{I18n.t('affiliate.instant_tag')}</span>
                    </span>
                    <span className="instant-txt">{I18n.t('affiliate.instant_text')}</span>
                </div>
                <div className="hero-cta">
                    <a className="btn" id="heroBtn" href={PARTNER_REGISTER_URL}>
                        <span>{I18n.t('affiliate.join')}</span>
                        <ArrowIcon/>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <div className="ticker" aria-hidden="true">
        <div className="ticker-track">
            {tickerItems('a')}
            {tickerItems('b')}
        </div>
    </div>
</>;

export default AffiliatesHero;
